<script>
import { mapActions, mapState } from "vuex";
import AppAlert from "@/features/bootstrap/Alert";
import AppBalanceCard from "./balance-card.vue";
import AppExpiryBanner from "./expiry-banner.vue";
import AppTransactionList from "./transaction-list.vue";
import AppEmptyState from "./empty-state.vue";

export default {
  name: "AppCashback",

  components: {
    AppAlert,
    AppBalanceCard,
    AppExpiryBanner,
    AppTransactionList,
    AppEmptyState,
  },

  async mounted() {
    await Promise.all([
      this.fetchBalance({ http: this.$http }),
      this.fetchTransactions({ http: this.$http }),
    ]);

    this.setLoading({ loading: false });
  },

  methods: {
    ...mapActions("Cashback", [
      "setLoading",
      "fetchBalance",
      "fetchTransactions",
    ]),
  },

  computed: {
    ...mapState("Cashback", {
      loading: (state) => state.cashback.loading,
      balance: (state) => state.cashback.balance,
      transactions: (state) => state.cashback.transactions,
      hasMore: (state) => state.cashback.hasMore,
      loadingMore: (state) => state.cashback.loadingMore,
      totalCount: (state) => state.cashback.totalCount,
      messages: (state) => state.cashback.messages,
    }),

    /**
     * Indica se não há transações e o carregamento já terminou.
     * @return {boolean}
     */
    isEmpty() {
      return !this.loading && this.transactions.length === 0;
    },
  },
};
</script>

<template>
  <section class="app__cashback" :class="{ app__loading: loading }">
    <header class="app__cashback__header mb-4">
      <h2 class="app__cashback__title" :class="{ app__loading: loading }">
        Cashback
      </h2>
    </header>

    <app-alert :messages="messages" />

    <app-expiry-banner :balance="balance" />

    <app-balance-card :balance="balance" :loading="loading" />

    <app-empty-state v-if="isEmpty" />

    <app-transaction-list
      v-else-if="!loading"
      :transactions="transactions"
      :has-more="hasMore"
      :loading-more="loadingMore"
      :total-count="totalCount"
    />
  </section>
</template>
